import React from 'react';
import { inject, observer } from 'mobx-react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Flex, Box } from 'grid-styled';

import Input from 'components/Input/Input';
import LoginView from 'components/LoginView/LoginView';
import Button from 'components/Button/Button';
import P from 'components/P/P';
import Ahref from 'components/Ahref/Ahref';
import { ROUTE_FORGOT, ROUTE_SIGNUP } from 'RouteList';

import messages from './messages';
import { isEmailValid } from '../../utils/email';
import { ROUTE_SET_PASSWORD } from '../../RouteList';

@inject('authStore', 'routing')
@observer
class Login extends React.Component {
  state = {
    username: '',
    password: '',
    usernameError: false,
    passwordError: false,
    error: null
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.classList.add('blue');
  }

  async handleSubmit(event) {
    event.preventDefault();
    const { authStore, routing: { push } } = this.props;
    const { username, password } = this.state;
    this.setState({ error: null, usernameError: false, passwordError: false });
    const response = await authStore.login(username.toLowerCase(), password);
    if (response.error) {
      if (response.newPasswordRequired) {
        push(ROUTE_SET_PASSWORD);
      } else {
        this.setState({
          error: response.error.message,
          usernameError: true,
          passwordError: true
        });
      }
    }
  }
  updateUsername(event) {
    this.setState({
      username: event.target.value
    });
  }
  updatePassword(event) {
    this.setState({
      password: event.target.value
    });
  }

  onSignupClick() {
    const { push } = this.props.routing;
    push(ROUTE_SIGNUP);
  }
  onForgotClick() {
    const { push } = this.props.routing;
    push(ROUTE_FORGOT);
  }

  render() {
    const {
      username,
      password,
      usernameError,
      passwordError,
      error
    } = this.state;
    const { intl: { formatMessage } } = this.props;
    const title = formatMessage(messages.loginTitle);
    const message = formatMessage(messages.loginMessage);

    return (
      <LoginView title={title} message={message}>
        <form onSubmit={e => this.handleSubmit(e)}>
          {error && (
            <Box mb={10}>
              <P danger>{error}</P>
            </Box>
          )}
          <Box mb={3}>
            <Input
              placeholder={formatMessage(messages.loginUsername)}
              onChange={e => this.updateUsername(e)}
              value={username}
              type="text"
              error={usernameError}
            />
          </Box>
          <Box mb={3}>
            <Input
              onChange={e => this.updatePassword(e)}
              placeholder={formatMessage(messages.loginPassword)}
              value={password}
              type="password"
              error={passwordError}
            />
          </Box>
          <Flex flexWrap="wrap">
            <Box width={[1, 1, 1 / 2]} mb={[3, 3, 0]}>
              <Button
                disabled={!username || !password || !isEmailValid(username)}
                secondary
              >
                <FormattedMessage {...messages.loginSubmitButton} />
              </Button>
            </Box>
            <Flex
              width={[1, 1, 1 / 2]}
              justifyContent="space-between"
              flexWrap="wrap"
              alignItems="center"
            >
              <Box width={1 / 1}>
                <Ahref onClick={() => this.onSignupClick()}>
                  <FormattedMessage {...messages.loginSignup} />
                </Ahref>
              </Box>
              <Box width={1 / 1}>
                <Ahref onClick={() => this.onForgotClick()}>
                  <FormattedMessage {...messages.loginPasswordForgotten} />
                </Ahref>
              </Box>
            </Flex>
          </Flex>
        </form>
      </LoginView>
    );
  }
}

export default injectIntl(Login);



// WEBPACK FOOTER //
// ./src/containers/login/Login.js